import { createFileRoute } from '@tanstack/react-router'
import { Inbox } from 'pages/inbox/Inbox'

export const Route = createFileRoute('/inspection-dashboard/')({
  component: Inbox,
  staticData: {
    title: 'Inspection Dashboard',
  },
})
